import { Component, Input, OnInit } from '@angular/core';
import { Store } from '@ngxs/store';
import { Locations, Performance } from 'county-api';
import maxBy from 'lodash/maxBy';
import { LocationsState } from '../../../../locations/store/locations.state';

interface IPerformanceLocationWidths {
    locationId: number,
    location: string;
    width: number;
    amount: number;
}

@Component({
    selector: 'revenue-locations',
    templateUrl: './revenue-locations.component.html',
    styleUrls: ['./revenue-locations.component.scss'],
})
export class RevenueLocationsComponent implements OnInit {
    locations: { [key: number]: Locations.ILocation };

    private _performanceData: Performance.IPerformanceMonthly[];

    get performanceData() {
        return this._performanceData;
    }
    @Input()
    set performanceData(performanceData: Performance.IPerformanceMonthly[]) {
        this._performanceData = performanceData;
    }

    @Input()
    targets : Performance.IPerformanceTarget[] = [];

    performanceWidths: IPerformanceLocationWidths[];

    constructor(private store: Store) {}

    ngOnInit() {
        this.locations = this.store.selectSnapshot(LocationsState.locationsMap);
        this.calculateWidths();
    }

    calculateWidths() {
        const widths: IPerformanceLocationWidths[] = [];

        if (this.performanceData && this.performanceData.length > 0) {
            const estimateMax =
                maxBy(this.performanceData, 'adjusted_estimate')
                    .adjusted_estimate + 10;
            const max = Math.max(estimateMax, 120);

            // Loops performance data to get the data for each individual location.
            for (let i = 0; i < this.performanceData.length; i++) {
                const locationData = this.performanceData[i];
                const location = this.locations[locationData.location_id];

                if (location) {
                    // Pushes the object to the widths array.
                    widths.push({
                        locationId: location.id,
                        location: location.name,
                        width: (locationData.adjusted_estimate / max) * 100,
                        amount: locationData.adjusted_estimate,
                    });
                }
            }
        }

        this.performanceWidths = widths;
    }

    getBranchGreatTargetProgress(locationId: number){
        const branchTargetDetail = this.targets.find(x => x.location_id === locationId);
        if (!branchTargetDetail || branchTargetDetail.great_target === 0){
            return 0;
        }

        const branchPerformance = this.performanceData.find(x => x.location_id === locationId);
        if(!branchPerformance){
            return 0;
        }


        return (branchPerformance.revenue / branchTargetDetail.great_target) * 100;
    }
}
